import {
  Box,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
} from '@chakra-ui/react'
import { useContext } from 'react'

import { usePopUpMessage } from '@hb/react'
import { SearchAssessments } from '../Assessments/SearchAssessments'
import { FaxesViewContext } from './context'
// uses FaxesViewContext to prompt the user to select a
// patient and then an assessment belonging to that patient
export const AssignFaxToAssessmentModal = () => {
  const {
    faxAssignment: { assigningToFaxId, assignToFax, onSubmit },
  } = useContext(FaxesViewContext)
  const { showError } = usePopUpMessage()

  return (
    <Modal
      isOpen={!!assigningToFaxId}
      onClose={() => assignToFax(null)}
      size="xl"
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton top={1} />
        <ModalBody borderRadius={6} p={0} bg="gray.100">
          <HStack py={2} px={4}>
            <Text fontFamily="Hero-New">Assign Fax to Assessment</Text>
          </HStack>
          <Box pb={2} px={3}>
            <SearchAssessments
              onSubmit={async assessmentId => {
                if (!assessmentId) {
                  showError('Please select an assessment')
                  return
                }
                await onSubmit(assessmentId)
              }}
            />
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
